var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":_vm.$colors.penChecksTeal}})
}
var staticRenderFns = []

export { render, staticRenderFns }